// Alle Kategorien und Unterkategorien für EventConnect

export const CATEGORIES = {
  'Fotografen & Videografen': [
    'Hochzeitsfotografie',
    'Eventfotografie',
    'Business- / Corporate-Fotografie',
    'Familien- und Babyshootings',
    'Portraitfotografie',
    'Produktfotografie',
    'Videografie für Events',
    'Imagefilme / Werbevideos',
    'Social-Media-Content-Creation'
  ],
  'Make-up & Styling': [
    'Brautstyling',
    'Event-Make-up',
    'Hairstyling',
    'Styling für Fotoshootings',
    'Special Effects Make-up',
    'Männliches Grooming'
  ],
  'Catering & Foodtrucks': [
    'Full-Service-Catering',
    'Fingerfood & Häppchen',
    'BBQ & Grill-Catering',
    'Veganes & Vegetarisches Catering',
    'Dessert & Candy Bar',
    'Foodtrucks (Burger, Pizza, Streetfood)',
    'Barservice & Cocktails',
    'Barista & Kaffeebar'
  ],
  'Deko & Eventdesign': [
    'Hochzeitsdekoration',
    'Firmen-Event-Dekoration',
    'Ballondekoration',
    'Floristik & Blumendeko',
    'Tischdekoration',
    'Raum- / Bühnenkonzepte',
    'Lichtdesign & Ambientebeleuchtung'
  ],
  'Technik & Equipment-Verleih': [
    'Ton- und Lichttechnik',
    'Bühnenbau',
    'Videotechnik & LED-Wände',
    'Eventmöbel & Loungemöbel',
    'Zelte & Pavillons',
    'Fotoboxen / Photobooth',
    'Konferenztechnik'
  ],
  'Musik & Entertainment': [
    'DJ',
    'Sänger / Sängerin',
    'Live-Band',
    'Solo-Musiker (Gitarre, Klavier etc.)',
    'Zauberer',
    'Jongleure',
    'Comedy / Kabarett',
    'Walking Acts',
    'Showacts (Feuershow, Akrobatik)'
  ],
  'Eventplanung & Organisation': [
    'Hochzeitsplaner',
    'Eventagenturen',
    'Messe-Organisation',
    'Firmenveranstaltungen',
    'Private Feier-Planung'
  ],
  'Kinder- & Familien-Entertainment': [
    'Kinderanimateure',
    'Clowns',
    'Kinderschminken',
    'Hüpfburgen & Spielgeräte',
    'Zauberer für Kinder'
  ],
  'Locations & Räume': [
    'Eventlocations',
    'Hochzeitslocations',
    'Tagungs- und Konferenzräume',
    'Partyräume',
    'Outdoor-Locations'
  ],
  'Personal & Service': [
    'Servicekräfte',
    'Barkeeper',
    'Kellner',
    'Hostessen & Promoter',
    'Security'
  ],
  'Fahrservice & Transport': [
    'Chauffeurservice',
    'Limousinenservice',
    'Oldtimer für Hochzeiten',
    'Shuttle-Service',
    'Logistik / Transport für Eventtechnik'
  ],
  'Branding & Druck': [
    'Werbetechnik (Roll-Ups, Banner)',
    'Eventbeschilderung',
    'Einladungskarten & Papeterie',
    'Giveaways & Merchandising'
  ],
  'Show & Performance': [
    'Tänzer & Tanzgruppen',
    'Akrobatik & Zirkusacts',
    'Feuershows',
    'Moderatoren & Hosts',
    'Sprecher & Voice-over'
  ],
  'Foto- / Fun-Module': [
    'Fotoboxen / Photobooths',
    '360°-Videobooths',
    'Green-Screen-Stationen',
    'Selfie-Stationen'
  ],
  'Weiterbildung & Workshops': [
    'Barista-Workshops',
    'Cocktail-Workshops',
    'Tanzkurse',
    'Fotografiekurse',
    'Make-up-Workshops'
  ],
  'Sonstiges & Spezial': [
    'Hochzeitsredner / freie Redner',
    'Trauredner',
    'Künstlerische Live-Maler',
    'Karikaturisten',
    'Special-Effects (Konfettikanonen, Pyrotechnik)'
  ]
};

export const getCategoryList = () => Object.keys(CATEGORIES);
export const getSubcategories = (category) => CATEGORIES[category] || [];
